/* eslint-disable restrict-imports/restrict-imports */
/* eslint-disable complexity */
import React, { useEffect, useState, useMemo, useCallback } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { makeStyles } from 'design-system/styles';
import { CircularProgress, Checkbox } from 'react-scale/components/design-system';
import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@material-ui/icons/Close';
import { useProjectGroups } from '../hooks/API';

import { TextInput, Select, Option } from 'design-system';

import { Button } from 'design-system/Button';

import { useGetProjectGroup } from 'react-scale/corp/views/DailyPlanning/hooks/queries';
import { INamedObjectTypes } from '@scale/shared/types/lookup';
import SmartLink from 'corp/components/SmartLink/SmartLink';
import cs from 'classnames';
import {
  ProjectGroupLifecyle,
  AvailableSLACadence,
  IDailyPlanProjectGroup,
  ACTIVE_STATUSES,
  AvailableBuisnessUnitProduct,
  AvailableBuisnessUnit,
  AvailableFulfillmentMechanism,
  BusinessUnitProductMapping,
  StatusMapping,
  IProjectSLAGroup,
  IHistory,
} from '@scale/shared/dailyPlan/dailyPlanProjectGroup';
import SelectProject from 'corp/components/UI/SelectProject';
import {
  buildProjectGroupDiff,
  filterProjectGroupStatus,
} from 'react-scale/corp/views/DailyPlanning/utils';
import {
  CreateProjectGroupRequest,
  UpdateProjectGroupRequest,
  CreateProjectGroupResponse,
} from '@scale/shared/dailyPlan/types/api';

import { UpdateProjectGroup } from 'react-scale/corp/views/DailyPlanning/ProjectGroups/ProjectGroupsPage';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import { useHistory } from 'react-router-dom';
import apiFetch, { defaultApiFetchErrorHandler, HTTPError } from '@scale/frontend-lib/api-fetch';
import { IProjectRole } from '@scale/shared/corp/projectRoles';
import { BusinessUnit, DAY_MS } from '@scale/shared/defaults';
import { ProjectRoleModifyRequest } from '@scale/shared/qm/qmRequestTypes';
import ProjectRolesResultsPopup, {
  ProjectRoleResult,
} from 'corp/components/CorpRoles/ProjectRolesResultsPopup';

interface ProjectGroupPageProps {
  match?: {
    params: {
      projectGroupId: string;
    };
  };
  onClose?: () => void;
  initialValues?: {
    [key: string]: string | string[];
  };
  onSave?: (details?: CreateProjectGroupResponse) => void;
  hideProjects?: boolean;
  skipSave?: boolean;
  returnData?: (details?: IProjectSLAGroup) => void;
}

const DEFAULT_INITIAL_VALUES = {
  name: '',
  projectIds: [] as string[],
  description: '',
  projectGroupId: '',
  fulfillmentMechanism: '',
};

export interface IDuplicatedProjects {
  projectsIds: { id: string; projectGroupId: string }[];
  projectGroupsNames: string[];
}
interface IFieldSelectorProps {
  options?: string[];
  fieldValue: string | undefined;
  setFieldView: (pageView: string) => void;
  fieldName: string;
  placeholder: string;
  skipStartCase?: boolean;
}

function FieldSelector({
  options,
  fieldValue,
  setFieldView,
  fieldName,
  placeholder,
  skipStartCase,
}: IFieldSelectorProps) {
  const fieldMapping = {
    status: ProjectGroupLifecyle,
    slaCadence: AvailableSLACadence,
    businessUnitProduct: AvailableBuisnessUnitProduct,
    businessUnit: AvailableBuisnessUnit,
    fulfillmentMechanism: AvailableFulfillmentMechanism,
  };

  const NamingMapping = {
    status: StatusMapping,
  };

  return (
    <>
      <Select
        value={fieldValue}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldView(e.target.value)}
        placeholder={placeholder}
      >
        {options
          ? options.map(element => (
              <Option value={element} key={element}>
                {element}
              </Option>
            ))
          : Object.entries(_.get(fieldMapping, fieldName, {})).map(([k, p]) => (
              <Option value={p} key={k}>
                {_.get(NamingMapping, `${fieldName}.${k}`, skipStartCase ? p : _.startCase(k))}
              </Option>
            ))}
      </Select>
    </>
  );
}

const ChangelogComponent = ({ history }: { history: IHistory }) => {
  let addedProjects: string[] = [];
  let removedProjects: string[] = [];
  if (history.field === 'projectIds') {
    addedProjects = _.difference(history.newValue as string[], history.oldValue as string[]);
    removedProjects = _.difference(history.oldValue as string[], history.newValue as string[]);
  }

  return (
    <>
      <div className="log-container">
        <div className="log-message">
          {addedProjects.length > 0 && (
            <div>
              <SmartLink type={INamedObjectTypes.User} id={history.updatedBy} /> added{' '}
              <span className="log-token-min">
                {addedProjects.map(project => (
                  <SmartLink key={project} type={INamedObjectTypes.Project} id={project} />
                ))}
              </span>
            </div>
          )}

          {removedProjects.length > 0 && (
            <div
              style={{
                paddingTop: addedProjects.length > 0 ? '10px' : '0px',
                marginTop: addedProjects.length > 0 ? '10px' : '0px',
              }}
            >
              <SmartLink type={INamedObjectTypes.User} id={history.updatedBy} /> removed{' '}
              <span className="log-token-min">
                {removedProjects.map(project => (
                  <SmartLink key={project} type={INamedObjectTypes.Project} id={project} />
                ))}
              </span>
            </div>
          )}

          {!['projectIds', '_history'].includes(history.field) && (
            <div>
              <SmartLink type={INamedObjectTypes.User} id={history.updatedBy} /> changed
              <span className="log-token">{history.field}</span> from{' '}
              <span className="log-token">{history.oldValue}</span> to{' '}
              <span className="log-token">{history.newValue}</span>.
            </div>
          )}
        </div>
        <div className="log-date">{moment(history.updatedAt).format('hh:mma on MMM DD, YYYY')}</div>
      </div>
      <style jsx>{`
        .log-container {
          padding: 10px 10px;
          display: flex;
          justify-content: space-between;
          align-items: left;
          font-size: 14px;
        }
        .log-date {
          min-width: 150px;
          padding-left: 8px;
          color: #aaa;
          font-style: italic;
          font-size: 12px;
        }
        .log-token {
          font-weight: bold;
          padding: 3px;
          border-radius: 3px;
          background: #eee;
        }
        .log-token-min {
          padding: 3px;
        }
      `}</style>
    </>
  );
};

const ProjectGroupPage: React.FC<ProjectGroupPageProps> = props => {
  const { match, onClose, initialValues, onSave, hideProjects, skipSave, returnData } = props;

  const projectGroupId = useMemo(() => {
    return _.get(match, 'params.projectGroupId');
  }, [match]);

  const { data, saveProjectGroup, error, editProjectGroup } = useProjectGroups({
    loading: true,
  });

  useEffect(() => {
    if (error) {
      defaultApiFetchErrorHandler(error as HTTPError, { handleHttp: true });
    }
  }, [error]);

  const classes = useStyles();
  const [showProjects, setShowProjects] = useState<boolean>(false);
  const [checkingDuplicates, setCheckingDuplicates] = useState<boolean>(true);
  const [endRoles, setEndRoles] = useState<boolean>(false);
  const [removeDuplicatedProjects, setRemoveDuplicatedProjects] = useState<boolean>(false);
  const [originalStatus, setOriginalStatus] = useState<string>('');
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [successSaving, setSuccessSaving] = useState<boolean>(false);
  const [projectRoleOperationsResults, setProjectRoleOperationsResults] = useState<
    ProjectRoleResult[]
  >([]);
  const [showResultsPopup, setShowResultsPopup] = useState<boolean>(false);
  const [businessUnitOptions, setBusinessUnitOptions] = useState<BusinessUnit[]>([]);

  const [values, setValues] = useState<IProjectSLAGroup>({
    ...DEFAULT_INITIAL_VALUES,
    ...{
      businessUnitProduct: projectGroupId ? '' : undefined,
      slaCadence: projectGroupId ? '' : undefined,
      status: projectGroupId ? '' : undefined,
      businessUnit: '',
      fulfillmentMechanism: projectGroupId ? '' : undefined,
    },
    ...initialValues,
  });

  useEffect(() => {
    if (successSaving) {
      setTimeout(() => {
        setSuccessSaving(false);
      }, 2000);
    }
  }, [successSaving]);

  const projectGroupsStatus: { [status: string]: IDailyPlanProjectGroup[] } = useMemo(() => {
    return filterProjectGroupStatus(data);
  }, [data]);

  const history = useHistory();

  const checkDuplicatedProjectIds = useCallback(
    (data: CreateProjectGroupRequest | UpdateProjectGroup): IDuplicatedProjects => {
      setCheckingDuplicates(true);
      const projectsIds: { id: string; projectGroupId: string }[] = [];
      const projectGroupsNames: string[] = [];
      if (!_.get(data, 'disabled', false)) {
        const projectGroupId = 'projectGroupId' in data ? data.projectGroupId : undefined;

        _.flatten(
          Object.entries(projectGroupsStatus).map(([_, projectGroups]) => projectGroups),
        ).forEach(projectGroup => {
          if (projectGroupId !== projectGroup.id) {
            const duplicatedIds = _.intersection(projectGroup.projectIds, data.projectIds);
            if (duplicatedIds.length > 0) {
              projectsIds.push(
                ...duplicatedIds.map(id => ({ id, projectGroupId: projectGroup.id })),
              );
              projectGroupsNames.push(projectGroup.name);
            }
          }
        });
      }
      setCheckingDuplicates(false);
      return {
        projectsIds,
        projectGroupsNames: Array.from(new Set(projectGroupsNames)),
      };
    },
    [projectGroupsStatus],
  );

  const handleSave = useCallback(async () => {
    try {
      setIsSaving(true);

      if (endRoles) {
        const projectRolesPromises: Promise<IProjectRole[]>[] = [];
        values.projectIds.forEach(projectId => {
          projectRolesPromises.push(
            apiFetch<IProjectRole[]>(null, `corp-api/qm/project_roles/?project=${projectId}`, {
              method: 'GET',
            }),
          );
        });
        const projectRolesResults = (await Promise.all(projectRolesPromises))
          .flat()
          .filter(
            projectRole =>
              !projectRole.stopDate ||
              (projectRole.stopDate && new Date(projectRole.stopDate) > new Date()),
          );

        const projectRolesToRemove: ProjectRoleModifyRequest = [];

        projectRolesResults.forEach(projectRole => {
          projectRolesToRemove.push({
            projectRoleId: projectRole._id!,
            newStartDate:
              new Date(projectRole.startDate) >= new Date()
                ? new Date(Date.now() - DAY_MS)
                : projectRole.startDate,
            newEndDate: new Date(),
          });
        });

        const endRolesResults = await apiFetch<(IProjectRole | Error)[]>(
          null,
          `corp-api/qm/project_role_events/`,
          {
            method: 'PATCH',
            body: projectRolesToRemove,
          },
        );
        setProjectRoleOperationsResults(
          endRolesResults.map(result => ({
            error: !!(result as Error).message,
            errorMessage: (result as Error).message || '',
            result,
          })),
        );
      }

      if ('projectGroupId' in values && values.projectGroupId) {
        const diff = buildProjectGroupDiff(values as UpdateProjectGroupRequest, projectGroupData);
        await editProjectGroup(
          values as UpdateProjectGroupRequest & { projectGroupId: string },
          diff,
        );
      } else {
        if (!skipSave) {
          const saveProjectResponse = await saveProjectGroup(values as UpdateProjectGroupRequest);
          if (saveProjectResponse) {
            onSave?.(saveProjectResponse);
          }
        }
        if (returnData) {
          returnData(values);
        }
      }
      onClose?.();
      setSuccessSaving(true);
    } finally {
      setIsSaving(false);
    }
  }, [skipSave, returnData, values]);

  function handleChangeField(name: string, value: string | string[]) {
    setValues({
      ...values,
      [name]: _.isArray(value) ? Array.from(new Set(value)) : value,
    });
  }

  function handleProjectField(projectId: string, removeProject?: boolean) {
    if (removeProject) {
      handleChangeField(
        'projectIds',
        values.projectIds.filter(id => id.trim() !== projectId),
      );
    } else {
      handleChangeField('projectIds', [...values.projectIds, projectId]);
    }
  }

  const duplicatedProjects = useMemo(() => {
    return checkDuplicatedProjectIds
      ? checkDuplicatedProjectIds({
          ...values,
          projectIds: values.projectIds,
        } as CreateProjectGroupRequest | UpdateProjectGroup)
      : {
          projectsIds: [],
          projectGroupsNames: [],
        };
  }, [values, checkDuplicatedProjectIds]);

  const { isLoading: projectGroupIsLoading, data: projectGroupData } = useGetProjectGroup({
    projectGroupId,
  });

  useEffect(() => {
    if (projectRoleOperationsResults.length > 0) {
      setShowResultsPopup(true);
    }
  }, [projectRoleOperationsResults]);

  useEffect(() => {
    if (projectGroupData) {
      setOriginalStatus(projectGroupData.status);
      setValues({
        name: projectGroupData.name,
        projectIds: projectGroupData.projectIds,
        description: projectGroupData.description,
        projectGroupId: projectGroupData.id,
        businessUnitProduct: projectGroupData?.businessUnitProduct,
        slaCadence: projectGroupData.slaCadence,
        status: projectGroupData.status,
        businessUnit: projectGroupData.businessUnit,
        fulfillmentMechanism: projectGroupData.fulfillmentMechanism,
      });
    }
  }, [projectGroupData, projectGroupId]);

  function handleClick(id: string) {
    history.push(`/daily_planning/${id}`);
  }

  const setValueByField = (fieldName: string, fieldValue: string) => {
    setValues(current => {
      return {
        ...current,
        [fieldName]: fieldValue,
      };
    });
  };

  const slaCadence = useMemo(() => {
    return values.slaCadence;
  }, [values]);

  const status = useMemo(() => {
    return values.status;
  }, [values]);

  const businessUnitProduct = useMemo(() => {
    if (values?.businessUnitProduct) {
      setBusinessUnitOptions(BusinessUnitProductMapping[values?.businessUnitProduct]);
    }
    return values?.businessUnitProduct;
  }, [values]);

  const businessUnit = useMemo(() => {
    return values?.businessUnit;
  }, [values]);

  const fulfillmentMechanism = useMemo(() => {
    return values?.fulfillmentMechanism;
  }, [values]);

  const _history = useMemo(() => {
    return (projectGroupData?._history || []).reverse();
  }, [projectGroupData]);

  return (
    <div className={classes.ownersList}>
      <div className={classes.ownersList} style={{ width: '100%' }}>
        <h2>
          {onClose ? 'Create' : 'Update'} Project SLA Group: {values.projectGroupId}
        </h2>

        <Tooltip title={'Open Daily Plan'} arrow>
          <IconButton
            disabled={!ACTIVE_STATUSES.includes(values.status || '')}
            edge="end"
            aria-label="Open Daily Plan"
            onClick={() => handleClick(values.projectGroupId)}
          >
            <OpenInNewIcon />
          </IconButton>
        </Tooltip>
      </div>
      <div className={classes.pageContainer} style={{ width: onClose ? '100%' : '50%' }}>
        {!projectGroupIsLoading ? (
          <div>
            <div>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <fieldset className={cs(classes.ownersList, classes.ownersBorder)}>
                    <legend className={classes.title}>
                      Name
                      <Tooltip
                        title={`The name for your Project SLA Group. This can be the same or different from your Project(s).`}
                        interactive
                        arrow
                      >
                        <IconButton edge="end" aria-label="Name" size="small">
                          <InfoIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                    </legend>
                    <div className={classes.statusContainer}>
                      <TextInput
                        type="text"
                        size="large"
                        value={values.name}
                        label=""
                        fullWidth
                        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                          handleChangeField('name', e.target.value as string)
                        }
                      />
                    </div>
                  </fieldset>
                </Grid>

                {!hideProjects && (
                  <Grid item xs={12}>
                    <fieldset className={cs(classes.ownersList, classes.ownersBorder)}>
                      <legend className={classes.title}>
                        Projects
                        <Tooltip
                          title={
                            duplicatedProjects.projectsIds.length > 0
                              ? `Projects cannot belong to more than 1 non-experimental Project SLA Group. Error with: ${duplicatedProjects.projectsIds
                                  .map(project => project.id)
                                  .join(' - ')}`
                              : 'These projects belong to your Project SLA Group. A project can only be in one non-experimental project SLA group.'
                          }
                          interactive
                          arrow
                        >
                          <IconButton
                            edge="end"
                            size="small"
                            aria-label="Duplicated Projects"
                            style={
                              duplicatedProjects.projectsIds.length > 0 ? { color: 'red' } : {}
                            }
                          >
                            <InfoIcon />
                          </IconButton>
                        </Tooltip>
                      </legend>
                      <div style={{ position: 'relative', zIndex: 10 }}>
                        <div style={{ margin: '5px' }}>
                          <SelectProject
                            // @ts-ignore FIXME - Typescript Strict [7006]
                            onChange={value => {
                              if (value) {
                                handleProjectField(value.value);
                              }
                            }}
                          />
                        </div>
                        {values.projectIds.length > 0 && (
                          <div>
                            <Button onClick={() => setShowProjects(current => !current)}>
                              {showProjects
                                ? 'Hide projects'
                                : `Show ${values.projectIds.length} Project${
                                    values.projectIds.length === 1 ? '' : 's'
                                  }`}
                            </Button>
                            <div className={cs(classes.ownersList, classes.ownerScroll)}>
                              {showProjects &&
                                values.projectIds.map((projectId, index) => (
                                  <Tooltip
                                    key={projectId}
                                    classes={{
                                      tooltip: classes.tooltip,
                                      tooltipPlacementTop: classes.tooltipPlacementTop,
                                      arrow: classes.arrow,
                                    }}
                                    title={
                                      !duplicatedProjects.projectsIds.find(
                                        project => project.id === projectId,
                                      ) ? (
                                        'To remove this project, add it to an existing project group or create a new project group'
                                      ) : (
                                        <div
                                          style={{
                                            backgroundColor: 'white',
                                            width: 'fit-content',
                                            height: 'fit-content',
                                            display: 'flex',
                                            alignItems: 'center',
                                          }}
                                        >
                                          <h2 style={{ marginRight: '5px' }}>Is part of: </h2>
                                          <SmartLink
                                            type={INamedObjectTypes.ProjectSLAGroup}
                                            id={
                                              duplicatedProjects.projectsIds.find(
                                                project => project.id === projectId,
                                              )?.projectGroupId || ''
                                            }
                                          />
                                        </div>
                                      )
                                    }
                                    interactive
                                    arrow
                                    placement="top"
                                  >
                                    <div
                                      className={cs(
                                        classes.ownerContainer,
                                        classes.projectContainer,
                                      )}
                                      key={index}
                                      style={{
                                        border: duplicatedProjects.projectsIds.find(
                                          project => project.id === projectId,
                                        )
                                          ? '2px solid red'
                                          : '2px solid #cccccc',
                                      }}
                                    >
                                      <SmartLink type={INamedObjectTypes.Project} id={projectId} />
                                      {duplicatedProjects.projectsIds.find(
                                        project => project.id === projectId,
                                      ) && (
                                        <IconButton
                                          edge="end"
                                          aria-label="Remove Project"
                                          onClick={() => handleProjectField(projectId, true)}
                                          size="small"
                                          style={{ color: 'red' }}
                                        >
                                          <CloseIcon fontSize="inherit" />
                                        </IconButton>
                                      )}
                                    </div>
                                  </Tooltip>
                                ))}
                            </div>
                          </div>
                        )}
                      </div>
                    </fieldset>
                  </Grid>
                )}

                <Grid item xs={6}>
                  <fieldset className={cs(classes.ownersList, classes.ownersBorder)}>
                    <legend className={classes.title}>
                      SLA Cadence
                      <Tooltip
                        title={`How are you delivering to customers? If you plan batches to deliver, it is planned deliveries. Most projects have planned deliveries`}
                        interactive
                        arrow
                      >
                        <IconButton edge="end" aria-label="SLA Cadence" size="small">
                          <InfoIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                    </legend>
                    <div className={classes.statusContainer}>
                      <FieldSelector
                        fieldValue={slaCadence}
                        setFieldView={slaCadence => {
                          setValueByField('slaCadence', slaCadence);
                        }}
                        fieldName={'slaCadence'}
                        placeholder="Select SLA Cadence"
                      />
                    </div>
                  </fieldset>
                </Grid>

                <Grid item xs={6}>
                  <fieldset className={cs(classes.ownersList, classes.ownersBorder)}>
                    <legend className={classes.title}>
                      Status
                      <Tooltip
                        title={`This is the status of your project. Select the status that best fits your project. For test projects, or random non-SLA bearing work, select "Experimental."`}
                        interactive
                        arrow
                      >
                        <IconButton edge="end" aria-label="Status" size="small">
                          <InfoIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                    </legend>
                    <div className={classes.statusContainer}>
                      <FieldSelector
                        fieldValue={status}
                        setFieldView={status => {
                          if (status === ProjectGroupLifecyle.Concluded) {
                            setEndRoles(true);
                          }
                          setValueByField('status', status);
                        }}
                        fieldName={'status'}
                        placeholder="Select Status"
                      />
                    </div>
                  </fieldset>
                </Grid>

                <Grid item xs={12} style={{ paddingTop: 0, paddingBottom: 0 }}>
                  <h4 style={{ color: 'var(--color-RemoGray75)' }}>
                    The following fields will be updated at the project and project group level
                  </h4>
                </Grid>

                <Grid item xs={6}>
                  <fieldset className={cs(classes.ownersList, classes.ownersBorder)}>
                    <legend className={classes.title}>
                      Business Unit Product
                      <Tooltip
                        title={`Select a business unit product that best fits this project.`}
                        interactive
                        arrow
                      >
                        <IconButton edge="end" aria-label="Fulfillment Method" size="small">
                          <InfoIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                    </legend>
                    <div className={classes.statusContainer}>
                      <FieldSelector
                        fieldValue={businessUnitProduct}
                        setFieldView={businessUnitProduct => {
                          setValueByField('businessUnitProduct', businessUnitProduct);

                          const possibleOptions =
                            BusinessUnitProductMapping[businessUnitProduct] ?? [];
                          setBusinessUnitOptions(possibleOptions);
                          if (possibleOptions.length) {
                            setValueByField('businessUnit', possibleOptions[0]);
                          } else {
                            setValueByField('businessUnit', '');
                          }
                        }}
                        fieldName={'businessUnitProduct'}
                        placeholder="Select Business Unit Product"
                        skipStartCase={true}
                      />
                    </div>
                  </fieldset>
                </Grid>

                <Grid item xs={6}>
                  <fieldset
                    className={cs(classes.ownersList, classes.ownersBorder)}
                    style={{ height: '82px' }}
                  >
                    <legend className={classes.title}>
                      Fulfillment Mechanism
                      <Tooltip
                        title={`Fulfillment mechanism is determined by the value you select for business unit product.`}
                        interactive
                        arrow
                      >
                        <IconButton edge="end" aria-label="businessUnit" size="small">
                          <InfoIcon fontSize="inherit" />
                        </IconButton>
                      </Tooltip>
                    </legend>

                    <div className={classes.statusContainer}>
                      <FieldSelector
                        fieldValue={fulfillmentMechanism}
                        setFieldView={fulfillmentMechanism => {
                          setValueByField('fulfillmentMechanism', fulfillmentMechanism);
                        }}
                        fieldName={'fulfillmentMechanism'}
                        placeholder="Select Fulfillment Mechanism"
                        skipStartCase={true}
                      />
                    </div>
                  </fieldset>
                </Grid>

                {businessUnitOptions.length ? (
                  <Grid item xs={6}>
                    <fieldset
                      className={cs(classes.ownersList, classes.ownersBorder)}
                      style={{ height: '82px' }}
                    >
                      <legend className={classes.title}>
                        Business Unit
                        <Tooltip
                          title={`Business unit is determined by the value you select for business unit product.`}
                          interactive
                          arrow
                        >
                          <IconButton edge="end" aria-label="businessUnit" size="small">
                            <InfoIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                      </legend>
                      <div className={classes.statusContainer}>
                        <FieldSelector
                          options={businessUnitOptions}
                          fieldValue={businessUnit}
                          setFieldView={businessUnit => {
                            setValueByField('businessUnit', businessUnit);
                          }}
                          fieldName={'businessUnit'}
                          placeholder="Select Business Unit"
                          skipStartCase={true}
                        />
                      </div>
                    </fieldset>
                  </Grid>
                ) : (
                  <></>
                )}

                <Grid item xs={12}>
                  <TextInput
                    type="text"
                    size="large"
                    value={values.description}
                    fullWidth
                    label="Description"
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      handleChangeField('description', e.target.value as string)
                    }
                  />
                </Grid>

                {originalStatus !== status && (
                  <Grid item xs={12}>
                    <Checkbox
                      checked={endRoles}
                      disabled={status === ProjectGroupLifecyle.Concluded}
                      onChange={e => setEndRoles(e.target.checked)}
                      label={'End all active roles in the projects'}
                      classes={{ checkboxRoot: classes.tickSize }}
                    ></Checkbox>
                  </Grid>
                )}
                {duplicatedProjects.projectsIds.length > 0 && (
                  <Grid item xs={12}>
                    <Checkbox
                      checked={removeDuplicatedProjects}
                      onChange={e => setRemoveDuplicatedProjects(e.target.checked)}
                      label={
                        <b>Confirm to remove added projects from their current project groups</b>
                      }
                      classes={{ checkboxRoot: classes.tickSize }}
                    ></Checkbox>
                  </Grid>
                )}
              </Grid>
            </div>
            <div
              style={{
                paddingTop: '15px',
                display: 'flex',
                justifyContent: values.projectGroupId ? 'flex-start' : 'flex-end',
              }}
            >
              {onClose && (
                <Button type="secondary" onClick={onClose} style={{ marginRight: '15px' }}>
                  Cancel
                </Button>
              )}
              <Button
                type="primary"
                disabled={
                  isSaving ||
                  successSaving ||
                  !values.name ||
                  (!hideProjects && values.projectIds.length === 0) ||
                  (!removeDuplicatedProjects && duplicatedProjects.projectsIds.length > 0) ||
                  !values.slaCadence ||
                  !values.status ||
                  !businessUnitProduct ||
                  !businessUnit ||
                  !fulfillmentMechanism ||
                  checkingDuplicates
                }
                onClick={handleSave}
              >
                {isSaving ? (
                  <CircularProgress size="20px" color="inherit" />
                ) : successSaving ? (
                  'Saved!'
                ) : (
                  `${values.projectGroupId ? 'Save' : 'Create'} Project SLA Group`
                )}
              </Button>
            </div>
          </div>
        ) : (
          <div className={classes.loadingSpacer}>
            <CircularProgress />
          </div>
        )}
        <ProjectRolesResultsPopup
          isModalOpen={showResultsPopup}
          hideModal={() => setShowResultsPopup(false)}
          title="End Roles: Results"
          results={projectRoleOperationsResults}
        />
      </div>
      {!onClose && _history && _history.length > 0 && (
        <div style={{ width: '50%' }}>
          <div className={classes.sections}>
            <div className={classes.historySectionTitle}>History</div>
            {_history.map((history, index) => (
              <ChangelogComponent key={index} history={history} />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const useStyles = makeStyles({
  sections: {
    flexDirection: 'column',
    flexWrap: 'wrap',
    padding: '10px',
    margin: '10px',
    background: 'var(--color-RemoGray01)',
    overflowY: 'auto',
    maxHeight: '700px',
    overfloX: 'hidden',
  },
  historySectionTitle: {
    fontSize: '20px',
    fontWeight: 500,
    padding: '5px 5px 0 5px',
  },
  ownersList: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  ownersBorder: {
    border: '2px solid #cccccc',
    borderRadius: '15px',
  },
  ownerScroll: {
    maxHeight: '400px',
    overflowY: 'scroll',
  },
  title: {
    color: '#8c8c8c',
  },
  loadingSpacer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: 300,
    height: '100%',
  },
  projectContainer: {
    border: '2px solid #cccccc',
    justifyContent: 'space-between',
    alignItems: 'center',
    margin: '5px',
  },
  ownerContainer: {
    padding: '5px',
    borderRadius: '12px',
    textOverflow: 'ellipsis',
    display: 'flex',
  },
  statusContainer: {
    padding: '5px',
    borderRadius: '12px',
    textOverflow: 'ellipsis',
    width: '100%',
  },
  pageContainer: {
    display: 'flex',
    width: '50%',
  },
  tickSize: {
    transform: 'scale(2)',
  },
  tooltip: {
    width: 'fit-content',
    maxWidth: '500px',
    background: '#FFFFFF',
    border: '1px solid rgb(204, 204, 204, 0.3)',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2), 0px 0px 5px rgba(0, 0, 0, 0.2)',
    color: 'black',
  },
  tooltipPlacementTop: {
    right: '1px',
    top: '8px',
  },
  arrow: {
    fontSize: 16,
    width: 17,
    '&::before': {
      border: '1px solid rgb(204, 204, 204, 0.3)',
      backgroundColor: '#fff',
      boxSizing: 'border-box',
    },
  },
});

export default ProjectGroupPage;
